import React, { useState, useContext } from "react";
import { Modal, Input, Radio, Image, message, Upload } from "antd";
import { getFunctionNamebyActionId, dynamicFunction } from "./dynamicFunction";
import RenderDynamicButton from "./renderDynamicButton";
import RenderModal from "./renderModalDynamic";
import StatusInfoModal from "../../../../components/utility/status_info_modal";
import { handleForm } from "../../../../contexts";
import ModalRejectExclusion from "./ModalRejectExclusion";
import ModalApproveExclusion from "./ModalApproveExclusion";
import ServiceApi from "../../../../services/ServiceApi";
import Cookies from "js-cookie";
import axios from "axios";
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
const initEmployment = {
  employment: null,
  employmentType: null,
  employmentReason: "",
};

export default function DynamicButton({
  CompanyId,
  OperatorId,
  ProjectId,
  workflow,
  page,
  language,
  factupdate,
  wrapClassName,
  Jobdetail,
  Jobdata,
}) {
  const [showCancel, setshowCancel] = useState(false);
  const [showManageMM, setshowManageMM] = useState(false);
  const [showManagesub, setshowManagesub] = useState(false);
  const [showAssignMM, setshowAssignMM] = useState(false);
  const [showAssignSub, setshowAssignSub] = useState(false);
  const [showmmAckjob, setshowmmAckjob] = useState(false);
  const [showSubackjob, setshowSubackjob] = useState(false);
  const [showstopTime, setshowstopTime] = useState(false);
  const [showModalSmsOn, setshowModalSmsOn] = useState(false);
  const [showModalSmsOff, setshowModalSmsOff] = useState(false);
  const [showRejectModal, setshowRejectModal] = useState(false);
  const [dataCloseDtac, setDataCloseDtac] = useState({
    tier1Name: "",
    tier2Name: "",
    tier3Name: "",
    fixProblemPictures: [],
    problemDetail: "",
    problemResult: "",

  });
  const [loading, setloading] = useState(false);
  const [soID, setSoID] = useState("");
  const [modalDisply, setModalDisply] = useState(false);
  const [modalMMDisply, setModalMMDisply] = useState(false);
  const [loadingText, setloadingText] = useState("Loading");
  const [Spin, setSpin] = useState(true);
  const [statusInfoModalMode, setstatusInfoModalMode] = useState("success");
  const { form, setshowReject } = useContext(handleForm) || {};
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [reasonData, setReasonData] = useState('');
  const [fileList, setFileList] = useState([]);
  const [showModalRejectExclusion, setShowModalRejectExclusion] =
    useState(false);
  const [showModalApproveExclusion, setShowModalApproveExclusion] =
    useState(false);
  const [selectWorkFlow, setSelectWorkFlow] = useState(null);

  //! new
  const [visibleEmployment, setVisibleEmployment] = useState(false);
  const [employment, setEmployment] = useState(initEmployment);
  //! new

  const ToggleModal = {
    setshowRejectModal: function (action) {
      setshowRejectModal(action);
    },
    setShowCancelJob: function (action) {
      setshowCancel(action);
    },
    setShowManageMM: function (action) {
      setshowManageMM(action);
    },
    setshowManagesub: function (action) {
      setshowManagesub(action);
    },
    setshowAssignMM: function (action) {
      setshowAssignMM(action);
    },
    setshowAssignSub: function (action) {
      setshowAssignSub(action);
    },
    setshowmmAckjob: function (action) {
      setshowmmAckjob(action);
    },
    setshowSubackjob: function (action) {
      setshowSubackjob(action);
    },
    setshowstopTime: function (action) {
      setshowstopTime(action);
    },
    setshowSmsOn: function (action) {
      setshowModalSmsOn(action);
    },
    setshowSmsOff: function (action) {
      setshowModalSmsOff(action);
    },
    setShowRejectExclusion: function (action) {
      setShowModalRejectExclusion(action);
    },
    setShowApproveExclusion: function (action) {
      setShowModalApproveExclusion(action);
    },
  };
  const callFunction = new dynamicFunction(
    CompanyId,
    OperatorId,
    ProjectId,
    Jobdetail,
    ToggleModal,
    setloading,
    setloadingText,
    setSpin,
    setstatusInfoModalMode,
    form,
    setshowReject
  );

  const btnMiddleware = async (btndetail) => {
    if (btndetail.next_main_action_id === 57) {
      const CloseToDtac = await ServiceApi.post("/JobMaxi/CloseToDtac", {
        "job_id": Jobdetail.job_id,
        "company_id": Jobdetail.company_id,
        "operator_id": Jobdetail.operator_id,
        "project_id": Jobdetail.project_id
      });
      if (CloseToDtac.data.result.code === "P") {
        setSoID(Jobdetail.so_id);
        setDataCloseDtac(CloseToDtac.data.data);
        setModalDisply(true);
      }
      else {
        message.error(CloseToDtac.data.result.showText);
      }
    }
    else if (btndetail.next_main_action_id === 58) {
      const CheckRejectToDtac = await ServiceApi.get("/JobMaxi/CheckRejectToDtac/" + Jobdetail.job_id);
      if (CheckRejectToDtac.data.result.code === "P") {
        setModalMMDisply(true);
      }
      else {
        message.error(CheckRejectToDtac.data.result.showText);
      }
    }
    else {
      if (btndetail.next_main_action_id !== 47) {
        const funcName = getFunctionNamebyActionId[btndetail.next_main_action_id];
        callFunction.btnMiddleware(funcName, btndetail);
        setSelectWorkFlow(btndetail);
      }
      else {
        const OperJobReOpen = await ServiceApi.post("/JobMaxi/OperJobReOpen", {
          "job_id": Jobdetail.job_id,
          "company_id": Jobdetail.company_id,
          "operator_id": Jobdetail.operator_id,
          "project_id": Jobdetail.project_id
        });
        if (OperJobReOpen.data.result.code === "P") {

          const funcName = getFunctionNamebyActionId[btndetail.next_main_action_id];
          callFunction.btnMiddleware(funcName, btndetail);
          setSelectWorkFlow(btndetail);
        }
        else {
          message.error(OperJobReOpen.data.result.showText);
        }
      }
    }
  };
  const statusInfoModalCallback = () => {
    setloading(false);
    window.location.reload();
  };

  const toDataURL = url => fetch(url)
    .then(response => response.blob())
    .then(blob => new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
      console.log('toDataURL',reader);
      return (reader)
    }))

  const dataURLtoFile = (dataurl, filename) => {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }
  const onCloseToDtac = async () => {

    const formData = new FormData();
    console.log('dataCloseDtac',dataCloseDtac);
    if (dataCloseDtac.fixProblemPictures.length > 0) {
      for (let index = 0; index < dataCloseDtac.fixProblemPictures.length; index++) {
        var convertFilesType = null;
        convertFilesType = dataURLtoFile(
          await toDataURL(
            ServiceApi.checkPath(
              dataCloseDtac.fixProblemPictures[index].pic_url_path, dataCloseDtac.fixProblemPictures[index].pic_upload_name
            ), dataCloseDtac.fixProblemPictures[index]["pic_upload_name"]
          ), dataCloseDtac.fixProblemPictures[index]["pic_upload_name"]
        );
        console.log('convertFilesType',convertFilesType);
        formData.append("so_id", soID);
        formData.append("JobDetail", dataCloseDtac.problemResult);
        formData.append("ProblemDetail", dataCloseDtac.problemDetail);
        formData.append("project_id", dataCloseDtac.projectId);
        formData.append("ResolutionTier1", dataCloseDtac.tier1Name);
        formData.append("ResolutionTier2", dataCloseDtac.tier2Name);
        formData.append("ResolutionTier3", dataCloseDtac.tier3Name);
        formData.append("LatLon", dataCloseDtac.latlon);
        formData.append("files", convertFilesType)
      }
    }
    else {
      formData.append("so_id", soID);
      formData.append("JobDetail", dataCloseDtac.problemResult);
      formData.append("ProblemDetail", dataCloseDtac.problemDetail);
      formData.append("project_id", dataCloseDtac.projectId);
      formData.append("ResolutionTier1", dataCloseDtac.tier1Name);
      formData.append("ResolutionTier2", dataCloseDtac.tier2Name);
      formData.append("ResolutionTier3", dataCloseDtac.tier3Name);
      formData.append("LatLon", dataCloseDtac.latlon);
    }


    await axios({
      method: "post",
      url: process.env.REACT_APP_URL_API + "JobItsm/ResolveJobItsm",
      data: formData,
      headers: {
        TokenUser: Cookies.get(`OperationToken`),
      },
      processData: false,
    })
      .then(function (response) {
        if (response.data.result.code === "P") {
          message.success("Close data success");
          setloadingText("Close data success");
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
        else {
          message.error("Close data failed.");
        }
      })
      .catch(function (response) {
        console.log(response);
      });
  }
  const onMmReject = async () => {

    const MmReject = await ServiceApi.post("/JobMaxi/MmReject", {
      "JobId": Jobdetail.job_id,
      "CompanyId": Jobdetail.company_id,
      "OperatorId": Jobdetail.operator_id,
      "ProjectId": Jobdetail.project_id,
      "Reason": reasonData,
      "Username": Cookies.get(`username`)
    });
    if (MmReject.data.result.code === "P") {
      const formData = new FormData();
      if(fileList.length > 0){
      for (let index = 0; index < fileList.length; index++) {
        formData.append("files", fileList[index]?.originFileObj);
        formData.append("job_id", Jobdetail?.job_id);
        formData.append("job_progress_id", Jobdetail?.job_progress_id);
        formData.append("company_id", Jobdetail.company_id);
        formData.append("operator_id", Jobdetail.operator_id);
        formData.append("project_id", Jobdetail.project_id);
        formData.append("job_category_id", Jobdetail?.job_category_id);
        formData.append("job_type_id", Jobdetail?.job_type_id);
        formData.append("asset_id", null);
        formData.append("create_by", Cookies.get(`username`));
        formData.append("pic_type", "R");
        formData.append("job_reference_id", MmReject.data.result.value);
      }
      
        await axios({
          method: "post",
          url: process.env.REACT_APP_URL_API + "job_detail/InsertImageListFile",
          data: formData,
          headers: {
            TokenUser: Cookies.get(`OperationToken`),
          },
          processData: false,
        })
          .then(function (response) {
            if (response.data.result.code === "P") {
              message.success("MM Reject Success");
              setloadingText("MM Reject  Success");
              setTimeout(() => {
                window.location.reload();
              }, 800);
            }
            else {
              message.error("MM Reject Failed.");
            }
          })
          .catch(function (response) {
            console.log(response);
          });
      }else{
        message.success("MM Reject Success");
        setloadingText("MM Reject  Success");
        setTimeout(() => {
          window.location.reload();
        }, 800);
      }
    }
    else {
      message.error(MmReject.data.result.showText);
    }

  }
  //  =============================  Upload Image =====================================
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };
  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  //  ==================================================================================
  return (
    <>
      {loading ? (
        <StatusInfoModal
          visible={loading}
          showSpinIcon={Spin}
          statusText={loadingText}
          mode={statusInfoModalMode}
          callbackFunction={statusInfoModalCallback}
        ></StatusInfoModal>
      ) : null}

      <RenderDynamicButton
        wrapClassName={wrapClassName}
        page={page}
        workflow={workflow}
        btnMiddleware={btnMiddleware}
      ></RenderDynamicButton>
      <RenderModal
        CompanyId={CompanyId}
        OperatorId={OperatorId}
        ProjectId={ProjectId}
        workflow={workflow}
        language={language}
        factupdate={factupdate}
        Jobdetail={Jobdetail}
        showRejectModal={showRejectModal}
        setshowRejectModal={setshowRejectModal}
        showCancel={showCancel}
        setshowCancel={setshowCancel}
        showManageMM={showManageMM}
        setshowManageMM={setshowManageMM}
        showManagesub={showManagesub}
        setshowManagesub={setshowManagesub}
        showAssignMM={showAssignMM}
        setshowAssignMM={setshowAssignMM}
        showAssignSub={showAssignSub}
        setshowAssignSub={setshowAssignSub}
        showmmAckjob={showmmAckjob}
        setshowmmAckjob={setshowmmAckjob}
        showSubackjob={showSubackjob}
        setshowSubackjob={setshowSubackjob}
        showstopTime={showstopTime}
        setshowstopTime={setshowstopTime}
        showModalSmsOn={showModalSmsOn}
        setshowModalSmsOn={setshowModalSmsOn}
        showModalSmsOff={showModalSmsOff}
        setshowModalSmsOff={setshowModalSmsOff}
        Jobdata={Jobdata}
      />

      <ModalRejectExclusion
        jobDetail={Jobdetail}
        visible={showModalRejectExclusion}
        onClose={() => setShowModalRejectExclusion(false)}
        workFlow={selectWorkFlow}
      />
      <ModalApproveExclusion
        jobDetail={Jobdetail}
        visible={showModalApproveExclusion}
        onClose={() => setShowModalApproveExclusion(false)}
        workFlow={selectWorkFlow}
      />
      <Modal
        className="bbtec-theme"
        title="ไม่พบ Employment กรุณากรอกข้อมูล"
        visible={visibleEmployment}
        // onOk={() => setVisibleRecommendation(false)}
        onCancel={() => setVisibleEmployment(false)}
      // bodyStyle={{ padding: 5 }}
      >
        <div className="row">
          <div className="col-6">
            <div className="row">
              <span className="font-thai-r fs-18">Employment</span>
            </div>
            <div className="row">
              <Radio.Group
                name="employment"
                value={employment.employment}
                onChange={(e) => {
                  const { value } = e.target;
                  setEmployment({
                    ...employment,
                    employment: value,
                  });
                }}
              >
                <Radio value={1}>
                  <span className="fs-18 c-blue">จ้าง</span>
                </Radio>
                <Radio value={2}>
                  <span className="fs-18 c-blue">ไม่จ้าง</span>
                </Radio>
              </Radio.Group>
            </div>
          </div>
          <div className="col-6">
            <div className="row">
              <span className="font-thai-r fs-18">Employment Type</span>
            </div>
            <div className="row">
              <Radio.Group
                name="employmentType"
                value={employment.employmentType}
                onChange={(e) => {
                  const { value } = e.target;
                  setEmployment({
                    ...employment,
                    employmentType: value,
                  });
                }}
              >
                <Radio value={1}>
                  <span className="fs-18 c-blue">จ้างเหมา</span>
                </Radio>
                <Radio value={2}>
                  <span className="fs-18 c-blue">จ้างรายครั้ง</span>
                </Radio>
              </Radio.Group>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-12">
            <div className="row">
              <span className="font-thai-r fs-18">Reason</span>
            </div>
            <div className="row">
              <Input.TextArea
                name="employmentReason"
                className="inputfile c-blue"
                value={employment.employmentReason}
                rows={2}
                onChange={(e) => {
                  const { value } = e.target;
                  setEmployment({
                    ...employment,
                    employmentReason: value,
                  });
                }}
              />
            </div>
          </div>
        </div>
      </Modal>

      <Modal title="Reqest Close" visible={modalDisply} onOk={() => onCloseToDtac()} width={800} onCancel={() => setModalDisply(false)}>
        <div className="row">
          <div className="col-4">{"Soid : "}</div>
          <div className="col-8">
            <span className="content-text" style={{ color: "#000f9f", fontSize: "0.8rem" }}>
              {soID || "-"}
            </span>
          </div>
          <div className="col-4 mt-2">{"Resolution Tier1 :"}</div>
          <div className="col-8">
            <span className="content-text" style={{ color: "#000f9f", fontSize: "0.8rem" }}>
              {dataCloseDtac?.tier1Name || "-"}
            </span>
          </div>
          <div className="col-4 mt-2">{"Resolution Tier2  :"}</div>
          <div className="col-8">
            <span className="content-text" style={{ color: "#000f9f", fontSize: "0.8rem" }}>
              {dataCloseDtac?.tier2Name || "-"}
            </span>
          </div>
          <div className="col-4 mt-2">{"Resolution Tier3  :"}</div>
          <div className="col-8">
            <span className="content-text" style={{ color: "#000f9f", fontSize: "0.8rem" }}>
              {dataCloseDtac?.tier3Name || "-"}
            </span>
          </div>
          <div className="col-4 mt-2">{"Problem Detail  :"}</div>
          <div className="col-8">
            <span className="content-text" style={{ color: "#000f9f", fontSize: "0.8rem" }}>
              {dataCloseDtac?.problemDetail || "-"}
            </span>
          </div>
          <div className="col-4 mt-2">{"รายละเอียดการแก้ไข  :"}</div>
          <div className="col-8">
            <span className="content-text" style={{ color: "#000f9f", fontSize: "0.8rem" }}>
              {dataCloseDtac?.problemResult || "-"}
            </span>
          </div>
          <div className="col-4 mt-2">{"Image"}</div>
          <div className="col-8 mt-2">
            {(dataCloseDtac ? dataCloseDtac.fixProblemPictures : []).map((data, i) => {
              return (
                <Image
                  width={80}
                  height={50}
                  src={data.pic_url_path + data.pic_upload_name}
                />
              )
            })}


          </div>
        </div>
      </Modal>


      <Modal title="MM Reject" visible={modalMMDisply} onOk={() => onMmReject()} width={800} onCancel={() => setModalMMDisply(false)}>
        <div className="row">
          <div className="col-4">{"Reason : "}</div>
          <div className="col-8">
            <Input.TextArea rows={4} placeholder="Reason" maxLength={50} onBlur={(e) => setReasonData(e.target.value)} />
          </div>

          <div className="col-4 mt-2">{"Image"}</div>
          <div className="col-8 mt-2">


            <Upload
              action={`${process.env.REACT_APP_URL_API}mockupupload/`}
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onChange={handleChange}
              multiple={true}
            >
              {fileList.length >= 8 ? null : uploadButton}
            </Upload>
          </div>
        </div>
      </Modal>
    </>
  );
}
